import React from "react";
import { Link } from "react-router-dom";
import styles from './glass.module.css';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { useGlobalState } from "../../global_state_components/GlobalStateProvider";

function Glass(props) {
  const {isMobile} = useGlobalState();
  
  return (
    // <div className={styles.glass styles.glass_shape styles.glass_texture}>
    <div className={`${styles.glass} ${styles.glass_shape} ${styles.glass_texture}`}>
      <Grid container spacing={0} className={styles.grid_container_class}>
        <Grid xs={isMobile? 12:8} className={styles.grid_left_child_class}>
          <p className={styles.nameplate}><span className= {styles.discuss}>Discuss</span><span className= {styles.learn}>learn</span></p>
          <img className={styles.discuss_img} src='/images/discuss_4_edge.svg' alt="discuss_4_image"/>
          {/*<p className={styles.tagline}>Learn anything you want through virtual discussions with similar interest people.</p>*/}
          {/* <p className={styles.tagline}>Learn anything you want through virtual discussions with people of similar interests.</p> */}
          <p className={styles.tagline}>Learn anything you want through virtual discussions with people who have similar interests from around the world.</p>
        </Grid>
        <Grid xs={isMobile? 12:4} className={styles.grid_right_child_class}>
          <Link className={styles.link} to="/signin">
            <button className = {styles.signin}>Login</button>
          </Link>
          <Link className={styles.link} to="/signup">
            <button className = {styles.signup}>Sign up</button>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}

export default Glass;